import { createConfig, http, type Transport } from 'wagmi'
import { metaMask } from 'wagmi/connectors'
import { SUPPORTED_DEPOSIT_CHAINS } from '@/lib/payment-chains'

const transports = SUPPORTED_DEPOSIT_CHAINS.reduce(
	(acc, chain) => {
		acc[chain.id] = http()
		return acc
	},
	{} as Record<(typeof SUPPORTED_DEPOSIT_CHAINS)[number]['id'], Transport>,
)

export const wagmiConfig = createConfig({
	chains: [...SUPPORTED_DEPOSIT_CHAINS],
	connectors: [metaMask()],
	transports,
})
